"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m8.599 12.871 5.288 4.594c.346.3.819.369 1.235.179s.675-.592.675-1.05V7.406A1.16 1.16 0 0 0 14.64 6.25c-.271 0-.537.097-.753.285l-5.288 4.594a1.155 1.155 0 0 0 0 1.742"
}), 'ArrowLeft');
